// extracted by mini-css-extract-plugin
module.exports = {"tabsContainer":"tab_tabsContainer__1g7ml","tabBtnContainer":"tab_tabBtnContainer__2q29Y","active":"tab_active__G3iEj","tabContainer":"tab_tabContainer__2IbEA"};